<h2 mat-dialog-title>Complete Schedule</h2>
<div mat-dialog-content>
    <div>
        <p>Are you sure you want to finish this schedule?</p>
    </div>
    <div *ngIf="outstandingOrders.length > 0">
        <app-bulk-process [orders]="outstandingOrders" [currentSchedule]="schedule"></app-bulk-process>
    </div>
    <div *ngIf="outstandingOrders.length === 0" class="flex-row justify-left">
        <mat-icon color="primary">check</mat-icon><p>All orders are scanned out of the vehicle</p>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button mat-dialog-close>Cancel</button>
        <button mat-raised-button cdkFocusInitial [disabled]="outstandingOrders.length > 0" (click)="completeSchedule()" color="primary">Complete Schedule</button>
    </div>
</div>